import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import api from '../../service/api';
import EtapaFonteAusente from './EtapaFonteAusente';
import '../../css/style.css';
import '../../css/ComposicaoCorporal.css';
import { HelpCircle, AlertCircle, Search, Ruler, Move3D, ScanFace, Info } from "lucide-react";
import { PieChart, Pie, Cell } from "recharts";
import Indicador from '../../images/indicador.png';

import imgDobraPeitoral from '../../images/dobra-peitoral.png';
import imgDobraAxilar from '../../images/dobra-axilar.png';
import { formatarNumero } from '../../utils/formato';

function ComposicaoCorporal({ setActiveTab, aluno, evaluationId, setEvaluationId, evaluationData, updateEvaluationData }) {
  // Navegação entre etapas
  const [etapa, setEtapa] = useState(1);
  const [totalEtapas, setTotalEtapas] = useState(2);
  const porcentagemConclusao = (etapa / totalEtapas) * 100;

  const avancarEtapa = () => {
    setEtapa(etapa + 1);
  };

  const retrocederEtapa = () => {
    if (etapa > 1) {
      setEtapa(etapa - 1);
    }
  };

  // Modal para próxima avaliacao
  const [isNextModal, setIsNextModal] = useState(false);
  const openNextModal = () => {
    setIsNextModal(true);
  };
  const closeNextModal = () => {
    setIsNextModal(false);
  };

  const [showInfoDireto, setShowInfoDireto] = useState(false);
  const [showInfoPerimetros, setShowInfoPerimetros] = useState(false);
  const [showInfoDobras, setShowInfoDobras] = useState(false);
  const [modalLaudoETreino, setModalLaudoETreino] = useState(false);

  // Dados antropométricos propagados de evaluationData.antropometria (vide useEffect abaixo).
  const [peso, setPeso] = useState('');
  const [perfil, setPerfil] = useState("homensEMulheresAdultos");
  const [idade, setIdade] = useState('');
  const [altura, setAltura] = useState('');
  const [sexo, setSexo] = useState('');
  const [IMC, setIMC] = useState('');
  const [pescoco, setPescoco] = useState('');
  const [abdomen, setAbdomen] = useState('');
  const [cintura, setCintura] = useState('');
  const [quadril, setQuadril] = useState('');

  // Modal dos protocolos recomendados
  const [isProtocoloTypeModal, setIsProtocoloTypeModal] = useState(false);

  const openProtocoloTypeModal = (arg) => {
    setIsProtocoloTypeModal(true);
  };
  const closeProtocoloTypeModal = () => {
    setIsProtocoloTypeModal(false);
  };

  // Popups de informações
  const [showInfo, setShowInfo] = useState(false);

  const [showInfoLegendaCorpo, setShowInfoLegendaCorpo] = useState("");

  // Lista de protocolos, para indicar um protocolo ao entrar na tela
  const protocolosPerimetros = [
    {
      label: "CUN-BAE (Clínica Universidad de Navarra)",
      value: "CUN-BAE",
      aplicavel: (sexo, idade) => idade >= 18 && idade <= 65,
    },
    {
      label: "Weltman et al. (1988)",
      value: "Weltman",
      aplicavel: (sexo, idade) => idade >= 18 && idade <= 65,
    },
    {
      label: "Marinha Americana (U.S. Navy Method)",
      value: "US Navy",
      aplicavel: (sexo, idade) => idade >= 18 && idade <= 60,
    },
    {
      label: "Deurenberg (1991)",
      value: "Deurenberg",
      aplicavel: (sexo, idade) => idade >= 18, // sem limite superior informado
    },
  ];

  const protocolosDobras = [
    {
      label: "Falkner - Homens e mulheres",
      value: "Falkner",
      aplicavel: (sexo, idade) => true, // todos
    },
    {
      label: "Sloan et all (1962) - Jovens (18-26 anos), homens e mulheres",
      value: "Sloan et all (1962)",
      aplicavel: (sexo, idade) => idade >= 18 && idade <= 26,
    },
    {
      label: "Durnin & Rahaman (1967) - Homens (18-34 anos), mulheres (18-29 anos)",
      value: "Durnin & Rahaman (1967)",
      aplicavel: (sexo, idade) =>
        (sexo === "Masculino" && idade >= 18 && idade <= 34) ||
        (sexo === "Feminino" && idade >= 18 && idade <= 29),
    },
    {
      label: "Jackson e Pollock - 7 Dobras - Homens (18-61 anos), mulheres (18-55 anos)",
      value: "Jackson e Pollock 7 Dobras",
      aplicavel: (sexo, idade) =>
        (sexo === "Masculino" && idade >= 18 && idade <= 61) ||
        (sexo === "Feminino" && idade >= 18 && idade <= 55),
    },
    {
      label: "Jackson e Pollock - 3 Dobras - Homens (18-61 anos), mulheres (18-55 anos)",
      value: "Jackson e Pollock 3 Dobras",
      aplicavel: (sexo, idade) =>
        (sexo === "Masculino" && idade >= 18 && idade <= 61) ||
        (sexo === "Feminino" && idade >= 18 && idade <= 55),
    },
    {
      label: "Durmin - Wormesley (1974) - Homens e mulheres (16-72 anos)",
      value: "Durmin - Wormesley (1974)",
      aplicavel: (sexo, idade) => idade >= 16 && idade <= 72,
    },
    {
      label: "Wilmore & Behnke (1969) - Homens (17-37 anos), mulheres (18-48 anos)",
      value: "Wilmore & Behnke (1969)",
      aplicavel: (sexo, idade) =>
        (sexo === "Masculino" && idade >= 17 && idade <= 37) ||
        (sexo === "Feminino" && idade >= 18 && idade <= 48),
    },
    {
      label: "Guedes (1994) - Brasileiros - Homens (17-27 anos), mulheres (18-30 anos)",
      value: "Guedes (1994) Brasileiros",
      aplicavel: (sexo, idade) =>
        (sexo === "Masculino" && idade >= 17 && idade <= 27) ||
        (sexo === "Feminino" && idade >= 18 && idade <= 30),
    },
    {
      label: "Petroski (1995) - Brasileiros - Homens (18-61 anos), mulheres (18-51 anos)",
      value: "Petroski (1995) Brasileiros",
      aplicavel: (sexo, idade) =>
        (sexo === "Masculino" && idade >= 18 && idade <= 61) ||
        (sexo === "Feminino" && idade >= 18 && idade <= 51),
    },
    {
      label: "Slaughter et al (1988) - Crianças e adolescentes",
      value: "Slaughter et al (1988)",
      aplicavel: (sexo, idade) => idade < 18,
    },
    // Ignorando Heyward e Stolarczyk (1996) - Atletas
  ];

  // Seleciona e armazena todos protocolos compatíveis
  const [protocolosCompatíveis, setProtocolosCompatíveis] = useState([]);

  // SALVAR E BUSCAR NO BD - LEVI 2/3
  // Método de avaliação
  const [metodoAvaliacao, setMetodoAvaliacao] = useState(false);

  // Se escolher metodo for direto, entrar com protocolo manualmente
  const [metodoDiretoUtilizado, setMetodoDiretoUtilizado] = useState("");

  // Protocolo selecionado (do método ativo)
  const [protocoloAvaliacao, setProtocoloAvaliacao] = useState("");

  // Cada método guarda o que foi registrado nele: assim, ao alternar entre Direto,
  // Perímetros e Dobras, nada é perdido e a tela reabre com o que já estava lá.
  const [protocoloPerimetros, setProtocoloPerimetros] = useState("");
  const [protocoloDobras, setProtocoloDobras] = useState("");
  const [percentualDireto, setPercentualDireto] = useState("");

  // Dados mais importantes
  const [percentualGordura, setPercentualGordura] = useState();
  const [percentualMassaMuscular, setPercentualMassaMuscular] = useState();
  const [percentualMassaOssea, setPercentualMassaOssea] = useState();
  const [percentualPesoResidual, setPercentualPesoResidual] = useState();
  const [FFMIcalculado, setFFMIcalculado] = useState();

  // FIM 2/3

  // Exibe o modal de protocolos sugeridos
  useEffect(() => {
    if (etapa === 2 && metodoAvaliacao === "Perimetros") {
      // Filtra os protocolos de perímetros aplicáveis
      const protocolosValidos = protocolosPerimetros.filter((protocolo) =>
        protocolo.aplicavel(sexo, idade)
      );
      setProtocolosCompatíveis(protocolosValidos);
      openProtocoloTypeModal();
    } else if (etapa === 3 && metodoAvaliacao === "Dobras") {
      // Filtra os protocolos de dobras aplicáveis
      const protocolosValidos = protocolosDobras.filter((protocolo) =>
        protocolo.aplicavel(sexo, idade)
      );
      setProtocolosCompatíveis(protocolosValidos);
      openProtocoloTypeModal();
    }
  }, [etapa, metodoAvaliacao, sexo, idade]);

  // Ao clicar no botão de escolher o método, navega entre as telas.
  // Retoma o protocolo e o percentual já registrados naquele método (em vez de zerar).
  const selecionaMetodo = (metodo) => {
    setMetodoAvaliacao(metodo);

    if (metodo === "Direto") {
      setProtocoloAvaliacao("");
      setPercentualGordura(percentualDireto !== "" ? percentualDireto : 0);
      setTotalEtapas(2);
    } else if (metodo === "Perimetros") {
      setProtocoloAvaliacao(protocoloPerimetros);
      // Zera antes de recalcular para o valor de outro método nunca vazar se o cálculo não for possível.
      setPercentualGordura(0);
      if (protocoloPerimetros) calculaPercentualPerimetros(protocoloPerimetros);
      setTotalEtapas(2);
    } else {
      setProtocoloAvaliacao(protocoloDobras);
      setPercentualGordura(0);
      if (protocoloDobras) calculaPercentualDobras(protocoloDobras);
      setTotalEtapas(3);
    }

    setEtapa(etapa + 1);
  }

  // Aplica o protocolo escolhido: guarda no método ativo e recalcula o percentual.
  const aplicaProtocolo = (protocoloSelecionado) => {
    setProtocoloAvaliacao(protocoloSelecionado);

    if (metodoAvaliacao === "Perimetros") {
      setProtocoloPerimetros(protocoloSelecionado);
      if (protocoloSelecionado) calculaPercentualPerimetros(protocoloSelecionado);
    } else if (metodoAvaliacao === "Dobras") {
      setProtocoloDobras(protocoloSelecionado);
      if (protocoloSelecionado) calculaPercentualDobras(protocoloSelecionado);
    }
  };

  const calculaPercentualProtocolo = (e) => aplicaProtocolo(e.target.value);

  // Opções do seletor do modal: os protocolos recomendados para o perfil e, quando o protocolo
  // já registrado não está entre eles, ele também entra — assim o seletor abre preenchido em vez
  // de vazio (um <select> sem opção correspondente ao valor não exibe nada).
  const opcoesProtocoloModal = (() => {
    if (!protocoloAvaliacao || protocolosCompatíveis.some((p) => p.value === protocoloAvaliacao)) {
      return protocolosCompatíveis;
    }
    const todos = metodoAvaliacao === "Dobras" ? protocolosDobras : protocolosPerimetros;
    const registrado = todos.find((p) => p.value === protocoloAvaliacao);
    return registrado ? [...protocolosCompatíveis, registrado] : protocolosCompatíveis;
  })();

  // ---------- Protocolos - Médotodo Direto (*NÃO POSSUI) ----------

  // ---------- Protocolos - Perímetros Corporais (*NÃO POSSUI) ----------
  const calculaPercentualPerimetros = (protocolo) => {
  let gc = null;

  switch (protocolo) {
    case 'CUN-BAE': {
      const constSexo = sexo === 'Masculino' ? 0 : 1;
      gc = -44.988
        + 0.503 * idade
        + 10.689 * constSexo
        + 3.172 * IMC
        - 0.026 * IMC * IMC
        + 0.181 * IMC * constSexo
        - 0.02 * IMC * idade
        - 0.005 * IMC * IMC * constSexo
        + 0.00021 * IMC * IMC * idade;
      break;
    }

    case 'Weltman': {
      // Nota clínica: Validado para populações com sobrepeso e obesas.
      if (sexo === 'Masculino') {
        gc = 0.31457 * abdomen - 0.10969 * peso + 10.8336;
      } else {
        // O relatório pede a circunferência abdominal média. Se tiver apenas 'abdomen', use-o.
        gc = 0.11077 * abdomen - 0.17666 * altura + 0.14354 * peso + 51.03301;
      }
      break;
    }

    case 'US Navy': {
      // Certifique-se de que abdomen, pescoco, cintura, quadril e altura estejam em centímetros (cm)
      if (sexo === 'Masculino') {
        gc = 86.010 * Math.log10(abdomen - pescoco) - 70.041 * Math.log10(altura) + 36.76;
      } else {
        gc = 163.205 * Math.log10(cintura + quadril - pescoco) - 97.684 * Math.log10(altura) - 78.387;
      }
      break;
    }

    case 'RFM': {
      // Altura e cintura precisam estar na mesma unidade (ex: centímetros)
      if (sexo === 'Masculino') {
        gc = 64 - 20 * (altura / cintura);
      } else {
        gc = 76 - 20 * (altura / cintura);
      }
      break;
    }

    case 'Deurenberg': {
      const constSexo = sexo === 'Masculino' ? 1 : 0;
      gc = 1.20 * IMC + 0.23 * idade - 10.8 * constSexo - 5.4;
      break;
    }

    default:
      gc = null;
  }

    if (gc !== null && !isNaN(gc)) {
      // Garante que o percentual não retorne valores bizarros/negativos em inputs zerados
      setPercentualGordura(gc < 0 ? 0 : gc); 
    }
  };
  /*
  const calculaPercentualPerimetros = (protocolo) => {
    let gc;

    switch (protocolo) {
      case 'CUN-BAE': {
        const constSexo = sexo === 'Masculino' ? 0 : 1;
        gc = -44.988
          + 0.503 * idade
          + 10.689 * constSexo
          + 3.172 * IMC
          - 0.026 * IMC * IMC
          + 0.181 * IMC * constSexo
          - 0.02 * IMC * idade
          - 0.005 * IMC * IMC * constSexo
          + 0.00021 * IMC * IMC * idade;
        break;
      }

      case 'Weltman': {
        if (sexo === 'Masculino') {
          gc = 0.782 * abdomen - (0.0826 * peso + 42.9);
          //console.log(gc);
        } else {
          gc = 0.789 * abdomen - (0.0806 * peso + 34.5);
        }
        break;
      }

      case 'US Navy': {
        if (sexo === 'Masculino') {
          gc = 86.010 * Math.log10(abdomen - pescoco) - 70.041 * Math.log10(altura) + 36.76;
        } else {
          gc = 163.205 * Math.log10(cintura + quadril - pescoco) - (97.684 * Math.log10(altura) - 78.387);
        }
        break;
      }

      case 'Deurenberg': {
        const constSexo = sexo === 'Masculino' ? 1 : 0;
        gc = 1.20 * IMC + 0.23 * idade - 10.8 * constSexo - 5.4;
        break;
      }

      default:
        gc = null;
    }

    if (gc !== null && !isNaN(gc)) {
      setPercentualGordura(gc);
    }
  };
  */


  // ---------- Protocolos - Dobras Cutâneas(*NÃO POSSUI) ----------

  //Imagem da dobra selecionada
  const [imagemDobra, setImagemDobra] = useState("");

  // SALVAR E BUSCAR NO BD - LEVI 3/3
  // Dados a serem coletados
  const [peitoral1, setPeitoral1] = useState("");
  const [peitoral2, setPeitoral2] = useState("");
  const [peitoral3, setPeitoral3] = useState("");
  const [mediaPeitoral, setMediaPeitoral] = useState(0);

  const [axilar1, setAxilar1] = useState("");
  const [axilar2, setAxilar2] = useState("");
  const [axilar3, setAxilar3] = useState("");
  const [mediaAxilar, setMediaAxilar] = useState(0);

  const [supraIliaca1, setSupraIliaca1] = useState("");
  const [supraIliaca2, setSupraIliaca2] = useState("");
  const [supraIliaca3, setSupraIliaca3] = useState("");
  const [mediaIliaca, setMediaIliaca] = useState(0);

  const [subescapular1, setSubescapular1] = useState("");
  const [subescapular2, setSubescapular2] = useState("");
  const [subescapular3, setSubescapular3] = useState("");
  const [mediaSubescapular, setMediaSubescapular] = useState(0);

  const [abdominal1, setAbdominal1] = useState("");
  const [abdominal2, setAbdominal2] = useState("");
  const [abdominal3, setAbdominal3] = useState("");
  const [mediaAbdominal, setMediaAbdominal] = useState(0);

  const [triceps1, setTriceps1] = useState("");
  const [triceps2, setTriceps2] = useState("");
  const [triceps3, setTriceps3] = useState("");
  const [mediaTriceps, setMediaTriceps] = useState(0);

  const [biceps1, setBiceps1] = useState("");
  const [biceps2, setBiceps2] = useState("");
  const [biceps3, setBiceps3] = useState("");
  const [mediaBiceps, setMediaBiceps] = useState(0);

  const [coxa1, setCoxa1] = useState("");
  const [coxa2, setCoxa2] = useState("");
  const [coxa3, setCoxa3] = useState("");
  const [mediaCoxa, setMediaCoxa] = useState(0);

  const [panturrilha1, setPanturrilha1] = useState("");
  const [panturrilha2, setPanturrilha2] = useState("");
  const [panturrilha3, setPanturrilha3] = useState("");
  const [mediaPanturrilha, setMediaPanturrilha] = useState(0);

  // FIM 3/3

  // Calcula a soma dos valores de uma coluna
  const calcularSomatoriaColuna = (colIndex) => {
    const valores = [
      [peitoral1, axilar1, supraIliaca1, subescapular1, abdominal1, triceps1, biceps1, coxa1, panturrilha1],
      [peitoral2, axilar2, supraIliaca2, subescapular2, abdominal2, triceps2, biceps2, coxa2, panturrilha2],
      [peitoral3, axilar3, supraIliaca3, subescapular3, abdominal3, triceps3, biceps3, coxa3, panturrilha3],
      [mediaPeitoral, mediaAxilar, mediaIliaca, mediaSubescapular, mediaAbdominal, mediaTriceps, mediaBiceps, mediaCoxa, mediaPanturrilha],
    ];

    const coluna = valores[colIndex];
    const soma = coluna.reduce((acc, valor) => acc + (parseFloat(valor) || 0), 0);
    return formatarNumero(soma, 2); // Formatar a soma com 2 casas decimais
  };

  // Calcula média dos valores da tabela. Ela valida se uma célula está vazia, para calcular a média de acordo com os dados preenchidos. Utilizada na função abaixo
  const calcularMedias = (...valores) => {
    const numerosValidos = valores
      .map((v) => parseFloat(v))
      .filter((v) => !isNaN(v));

    if (numerosValidos.length === 0) return null;

    const soma = numerosValidos.reduce((acc, curr) => acc + curr, 0);
    return soma / numerosValidos.length;
  };

  // Calcula as médias que serão necessárias
  const calculaMediaDobras = () => {
    setMediaPeitoral(calcularMedias(peitoral1, peitoral2, peitoral3));
    setMediaAxilar(calcularMedias(axilar1, axilar2, axilar3));
    setMediaIliaca(calcularMedias(supraIliaca1, supraIliaca2, supraIliaca3));
    setMediaSubescapular(calcularMedias(subescapular1, subescapular2, subescapular3));
    setMediaAbdominal(calcularMedias(abdominal1, abdominal2, abdominal3));
    setMediaTriceps(calcularMedias(triceps1, triceps2, triceps3));
    setMediaBiceps(calcularMedias(biceps1, biceps2, biceps3));
    setMediaCoxa(calcularMedias(coxa1, coxa2, coxa3));
    setMediaPanturrilha(calcularMedias(panturrilha1, panturrilha2, panturrilha3));
  }

  // Calcula média sempre que entrar com algum valor
  useEffect(() => {
    calculaMediaDobras();
  }, [peitoral1, axilar1, supraIliaca1, subescapular1, abdominal1, triceps1, biceps1, coxa1, panturrilha1,
    peitoral2, axilar2, supraIliaca2, subescapular2, abdominal2, triceps2, biceps2, coxa2, panturrilha2,
    peitoral3, axilar3, supraIliaca3, subescapular3, abdominal3, triceps3, biceps3, coxa3, panturrilha3
  ]
  );

  // Função que calcula o percentual de acordo com o protocolo de dobras
  const calculaPercentualDobras = (protocolo) => {

    let gc;

    switch (protocolo) {
      case 'Falkner': {
        gc = (mediaTriceps + mediaSubescapular + mediaIliaca + mediaAbdominal) * 0.153 + 5.783;
        setPercentualGordura(gc);
        break;
      }

      case 'Sloan et all (1962)': {
        if (sexo === 'Masculino') {
          const d = 1.1043 - 0.001327 * (mediaCoxa) - 0.001310 * (mediaSubescapular);
          gc = ((4.95 / d) - 4.5) * 100;
        } else {
          const d = 1.0764 - 0.00081 * (mediaIliaca) - 0.00088 * (mediaTriceps);
          gc = ((4.95 / d) - 4.5) * 100;
        }
        setPercentualGordura(gc);
        break;
      }

      case 'Durnin & Rahaman (1967)': {
        if (sexo === 'Masculino') {
          const d = 1.1610 - 0.0632 * Math.log10(mediaBiceps + mediaTriceps + mediaSubescapular + mediaIliaca);
          gc = ((4.95 / d) - 4.5) * 100;
        } else {
          const d = 1.1581 - 0.0720 * Math.log10(mediaBiceps + mediaTriceps + mediaSubescapular + mediaIliaca);
          gc = ((4.95 / d) - 4.5) * 100;
        }
        setPercentualGordura(gc);
        break;
      }

      case 'Jackson e Pollock 7 Dobras': {
        if (sexo === 'Masculino') {
          const somatorioDobras = mediaPeitoral + mediaAbdominal + mediaCoxa + mediaAxilar + mediaSubescapular + mediaIliaca + mediaTriceps;
          const d = 1.112 - (0.00043499 * somatorioDobras) + (0.00000055 * somatorioDobras * somatorioDobras) - (0.00028826 * idade);
          gc = ((4.95 / d) - 4.5) * 100;
        } else {
          const somatorioDobras = mediaTriceps + mediaIliaca + mediaCoxa + mediaAbdominal + mediaAxilar + mediaSubescapular + mediaPeitoral;
          const d = 1.097 - (0.00046971 * somatorioDobras) + (0.00000056 * somatorioDobras * somatorioDobras) - (0.00012828 * idade);
          gc = ((4.95 / d) - 4.5) * 100;
        }
        setPercentualGordura(gc);
        break;
      }

      case 'Jackson e Pollock 3 Dobras': {
        if (sexo === 'Masculino') {
          const somatorioDobras = mediaPeitoral + mediaAbdominal + mediaCoxa;
          const d = 1.1093800 - 0.0008267 * (somatorioDobras) + 0.0000016 * (somatorioDobras) * (somatorioDobras) - 0.0002574 * (idade);
          gc = ((4.95 / d) - 4.5) * 100;
        } else {
          const somatorioDobras = mediaTriceps + mediaIliaca + mediaCoxa;
          const d = 1.099492 - 0.0009929 * (somatorioDobras) + 0.0000023 * (somatorioDobras) * (somatorioDobras) - 0.0001392 * (idade);
          gc = ((4.95 / d) - 4.5) * 100;
        }
        setPercentualGordura(gc);
        break;
      }

      case 'Durmin - Wormesley (1974)': {
        const logSomatorioDobras = Math.log10(mediaBiceps + mediaTriceps + mediaSubescapular + mediaIliaca);
        if (sexo === 'Masculino') {
          let d;

          if (idade < 17) {
            d = 1.1533 - (0.0643 * logSomatorioDobras);
          } else if (idade < 20) {
            d = 1.1620 - (0.0630 * logSomatorioDobras);
          } else if (idade < 30) {
            d = 1.1631 - (0.0632 * logSomatorioDobras);
          } else if (idade < 40) {
            d = 1.1422 - (0.0544 * logSomatorioDobras);
          } else if (idade < 50) {
            d = 1.1620 - (0.0700 * logSomatorioDobras);
          } else {
            d = 1.1715 - (0.0779 * logSomatorioDobras);
          }
          gc = ((4.95 / d) - 4.5) * 100;
        }

        else {
          let d;

          if (idade < 17) {
            d = 1.1369 - (0.0598 * logSomatorioDobras);
          } else if (idade < 20) {
            d = 1.1549 - (0.0678 * logSomatorioDobras);
          } else if (idade < 30) {
            d = 1.1599 - (0.0717 * logSomatorioDobras);
          } else if (idade < 40) {
            d = 1.1423 - (0.0632 * logSomatorioDobras);
          } else if (idade < 50) {
            d = 1.1333 - (0.0612 * logSomatorioDobras);
          } else {
            d = 1.1339 - (0.0645 * logSomatorioDobras);
          }
          gc = ((4.95 / d) - 4.5) * 100;
        }
        setPercentualGordura(gc);
        break;
      }

      case 'Wilmore & Behnke (1969)': {
        if (sexo === 'Masculino') {
          const d = 1.08543 - 0.000886 * (mediaAbdominal) - 0.00040 * (mediaCoxa);
          gc = ((4.95 / d) - 4.5) * 100;
        } else {
          const d = 1.06234 - 0.00068 * (mediaSubescapular) - 0.00039 * (mediaTriceps) - 0.00025 * (mediaCoxa);
          gc = ((4.95 / d) - 4.5) * 100;
        }
        setPercentualGordura(gc);
        break;
      }

      case 'Guedes (1994) Brasileiros': {
        if (sexo === 'Masculino') {
          const logSomatorioDobras = Math.log10(mediaTriceps + mediaIliaca + mediaAbdominal);
          const d = 1.1714 - 0.0671 * (logSomatorioDobras);
          gc = ((4.95 / d) - 4.5) * 100;
        } else {
          const logSomatorioDobras = Math.log10(mediaCoxa + mediaIliaca + mediaSubescapular);
          const d = 1.1665 - 0.0706 * (logSomatorioDobras);
          gc = ((4.95 / d) - 4.5) * 100;
        }
        setPercentualGordura(gc);
        break;
      }

      case 'Petroski (1995) Brasileiros': {
        if (sexo === 'Masculino') {
          const somatorioDobras = mediaSubescapular + mediaTriceps + mediaIliaca + mediaPanturrilha;
          const d = 1.10726863 - 0.00081201 * (somatorioDobras) + 0.00000212 * (somatorioDobras) - 0.00041761 * (idade);
          gc = ((4.95 / d) - 4.5) * 100;
        } else {
          const logSomatorioDobras = Math.log10(mediaAxilar + mediaIliaca + mediaCoxa + mediaPanturrilha);
          const d = 1.19547130 - 0.07513507 * (logSomatorioDobras) - 0.00041072 * (idade);
          gc = ((4.95 / d) - 4.5) * 100;
        }
        setPercentualGordura(gc);
        break;
      }

      case 'Slaughter et al (1988': {
        const somatorioDobras = mediaTriceps + mediaSubescapular;

        if ((somatorioDobras) < 35) {
          if (sexo === 'Masculino') {
            if (idade < 9) {
              gc = 1.21 * (somatorioDobras) - 0.008 * (somatorioDobras) * (somatorioDobras) - 1.7;
            } else if (idade < 11) {
              gc = 1.21 * (somatorioDobras) - 0.008 * (somatorioDobras) * (somatorioDobras) - 2.5;
            } else if (idade < 13) {
              gc = 1.21 * (somatorioDobras) - 0.008 * (somatorioDobras) * (somatorioDobras) - 3.4;
            } else if (idade < 15) {
              gc = 1.21 * (somatorioDobras) - 0.008 * (somatorioDobras) * (somatorioDobras) - 4.4;
            } else {
              gc = 1.21 * (somatorioDobras) - 0.008 * (somatorioDobras) * (somatorioDobras) - 5.5;
            }
          } else {
            gc = 1.33 * (somatorioDobras) - 0.0130 * (somatorioDobras) * (somatorioDobras) - 2.5;
          }
        } else {
          if (sexo === 'Masculino') {
            gc = 0.783 * (somatorioDobras) * (somatorioDobras) + 1.6;
          } else {
            gc = 0.546 * (somatorioDobras) + 9.7;
          }
        }
        setPercentualGordura(gc);
        break;
      }

      case 'Heyward e Stolarczyk (1996)': {
        if (sexo === 'Masculino') {
          const somatorioDobras = mediaPeitoral + mediaAxilar + mediaTriceps + mediaSubescapular + mediaAbdominal + mediaIliaca + mediaCoxa;
          const d = 1.112 - 0.00043499 * (somatorioDobras) + 0.00000055 * (somatorioDobras) * (somatorioDobras) - 0.00028826 * (idade);
          gc = ((4.95 / d) - 4.5) * 100;
        } else {
          const somatorioDobras = mediaTriceps + mediaAbdominal + mediaIliaca + mediaCoxa;
          const d = 1.096095 - 0.0006952 * (somatorioDobras) + 0.0000011 * (somatorioDobras) * (somatorioDobras) - 0.0000714 * (idade);
          gc = ((4.95 / d) - 4.5) * 100;
        }
        setPercentualGordura(gc);
        break;
      }
    }
  }

  // Dados para comparar os resultados
  // Para homens
  const faixasGorduraHomens = [
    { name: "Abaixo do normal", range: [0, 12], color: "#1E90FF" },         // Azul
    { name: "Normal", range: [12, 18], color: "#00c457" },                 // Verde
    { name: "Acima do normal", range: [18, 25], color: "#ffbb28" },        // Amarelo
    { name: "Tendência à obesidade", range: [25, 100], color: "#fb1d1d" }, // Vermelho
  ];

  // Para mulheres
  const faixasGorduraMulheres = [
    { name: "Abaixo do normal", range: [0, 16], color: "#1E90FF" },         // Azul
    { name: "Normal", range: [16, 25], color: "#00c457" },                 // Verde
    { name: "Acima do normal", range: [25, 33], color: "#ffbb28" },        // Amarelo
    { name: "Tendência à obesidade", range: [33, 100], color: "#fb1d1d" }, // Vermelho
  ];

  const getFaixasGC = (sexo) => {
    if (sexo === "Masculino") {
      return faixasGorduraHomens;
    }
    else {
      return faixasGorduraMulheres;
    }
  };

  const faixasGCcalculadas = getFaixasGC(sexo);

  // Cria o gráfico de barra com o indicador
  const GraficoBarraComIndicador = ({
    valor,
    faixas,
    largura = 340,
    altura = 25,
    corIndicador = "#fff",
    mostrarValor = false,
  }) => {
    const larguraSegmento = largura / faixas.length;

    // Encontra a faixa correspondente ao valor
    const faixaIndex = faixas.findIndex(
      (faixa) => valor >= faixa.range[0] && valor <= faixa.range[1]
    );

    let posicaoSeta = 0;

    if (faixaIndex !== -1) {
      const faixa = faixas[faixaIndex];
      const [min, max] = faixa.range;
      const percentualNaFaixa = (valor - min) / (max - min); // valor entre 0 e 1

      posicaoSeta = faixaIndex * larguraSegmento + percentualNaFaixa * larguraSegmento;
    }

    return (
      <div style={{ position: "relative", marginTop: "0px" }}>
        {/* Indicador (seta) */}
        <div
          style={{
            position: "absolute",
            left: `${posicaoSeta}px`,
            top: "10px",
            transform: "translateX(-50%) translateY(-14px)",
            fontSize: "20px",
            color: corIndicador,
            whiteSpace: "nowrap",
          }}
        >
          <img className="indicador-img" src={Indicador} alt="▲" />
          {mostrarValor && formatarNumero(valor, 1)}
        </div>

        {/* Barra segmentada com faixas de largura igual ▲ <img className="arrow-icon" src={LeviIcon} alt="corpo-humano" />*/}
        <div
          style={{
            display: "flex",
            height: `${altura}px`,
            width: `${largura}px`,
            overflow: "hidden",
            boxShadow: "0 0 4px rgba(0,0,0,0.1)",
          }}
        >
          {faixas.map((faixa, index) => {
            const borderRadiusStyle = {
              borderTopLeftRadius: index === 0 ? "2px" : "0px",
              borderBottomLeftRadius: index === 0 ? "2px" : "0px",
              borderTopRightRadius: index === faixas.length - 1 ? "2px" : "0px",
              borderBottomRightRadius: index === faixas.length - 1 ? "2px" : "0px",
            };

            return (
              <div
                key={index}
                style={{
                  width: `${larguraSegmento}px`,
                  backgroundColor: faixa.color,
                  ...borderRadiusStyle,
                }}
                title={`${faixa.name} (${faixa.range[0]} - ${faixa.range[1]})`}
              />
            );
          })}
        </div>
      </div>
    );
  };

  // Encontra as faixas mais gerais de classificação pra exibir nos resultados
  function encontrarFaixa(valor, faixas) {
    return faixas.find((faixa) =>
      valor >= faixa.range[0] && valor <= faixa.range[1]
    );
  }

  // Resultado na ultima tabela
  const avaliarPercentuais = () => {
    const percentual = Number(percentualGordura);
    const faixas = faixasGCcalculadas;

    // Encontra os limites da faixa "Normal"
    const faixaNormal = faixas.find(faixa => faixa.name === "Normal");
    if (!faixaNormal) {
      return { classificacao: "", gorduraExcedente: "" };
    }

    const [limiteInferior, limiteSuperior] = faixaNormal.range.map(Number);

    // Gordura abaixo
    if (percentual < limiteInferior) {
      return {
        classificacao: "Abaixo do normal",
        gorduraExcedente: "0%",
      };
    }

    // Gordura acima
    if (percentual > limiteSuperior) {
      const excesso = percentual - limiteSuperior;
      return {
        classificacao: percentual > faixas.find(f => f.name === "Acima do normal")?.range[1]
          ? "Tendência à obesidade"
          : "Acima do normal",
        gorduraExcedente: `${formatarNumero(excesso, 2)}% / ${formatarNumero((excesso / 100 * peso), 2)}Kg`,
      };
    }

    // Gordura ideal
    return {
      classificacao: "Adequado!",
      gorduraExcedente: "0%",
    };
  };

  // REMOVER ESSA FUNÇÂO DPS
  const avaliarPercentualGordura = (percentual, faixas) => {
    percentual = Number(percentual);
    // peso vem da antropometria como string; sem coagir, "peso + número" concatena e quebra .toFixed.
    const pesoNum = Number(peso) || 0;

    // Encontra os limites da faixa "Normal"
    const faixaNormal = faixas.find(faixa => faixa.name === "Normal");
    if (!faixaNormal) {
      return { tipoMeta: "", detalheMeta: "", gordura: "", ideal: "" };
    }

    const [limiteInferior, limiteSuperior] = faixaNormal.range.map(Number);

    if (percentual < limiteInferior) {
      const diff = limiteInferior - percentual;
      return {
        tipoMeta: "Abaixo do normal",
        detalheMeta: `${limiteInferior} % - ${formatarNumero(percentual, 2)} % = ${formatarNumero(diff, 2)} % abaixo do ideal`,
        gordura: `Deficiência de gordura: ${formatarNumero((diff / 100 * pesoNum), 2)} Kg`,
        ideal: `Limite inferior do peso corporal: ${formatarNumero((pesoNum + (diff / 100 * pesoNum)), 2)} Kg`
      };
    }

    if (percentual > limiteSuperior) {
      const excesso = percentual - limiteSuperior;
      return {
        tipoMeta: percentual > faixas.find(f => f.name === "Acima do normal")?.range[1]
          ? "Tendência à obesidade"
          : "Acima do normal",
        detalheMeta: `${formatarNumero(excesso, 2)} % acima do ideal`,
        gordura: `Excesso de gordura: ${formatarNumero((excesso / 100 * pesoNum), 2)} Kg`,
        ideal: `Limite superior do peso corporal: ${formatarNumero((pesoNum - (excesso / 100 * pesoNum)), 2)} Kg`
      };
    }

    return {
      tipoMeta: "Adequado!",
      detalheMeta: "Dentro da faixa considerada ideal",
      gordura: "",
      ideal: ""
    };
  };

  const dataPercentualGrafico = [
    { name: "Gordura", value: parseFloat(percentualGordura), color: "#ffbb28" },
    { name: "Massa Muscular", value: percentualMassaMuscular, color: "#00c457" },
    { name: "Massar Óssea", value: percentualMassaOssea, color: "#0088fe" },
    { name: "Peso Residual", value: percentualPesoResidual, color: "#ff4242" },
  ];

  const calculaComposicaoCorporal = () => {
    if (percentualGordura == null || isNaN(percentualGordura)) {
      setPercentualMassaMuscular(null);
      setPercentualMassaOssea(null);
      setPercentualPesoResidual(null);
      return;
    }

    const pesoGordura = (percentualGordura / 100) * peso;
    const pesoOsseo = sexo === "Masculino" ? peso * 0.15 : peso * 0.12;
    const pesoResidual = sexo === "Masculino" ? peso * 0.241 : peso * 0.209;
    const pesoMuscular = peso - (pesoGordura + pesoOsseo + pesoResidual);

    const pesoIsentoDeGorudra = peso - pesoGordura;

    const percMuscular = (pesoMuscular / peso) * 100;
    const percOsseo = (pesoOsseo / peso) * 100;
    const percResidual = (pesoResidual / peso) * 100;

    const alturaEmM = altura / 100;
    const valorFFMI = pesoIsentoDeGorudra / (alturaEmM ** 2);

    console.log("pesoIsento: " + pesoIsentoDeGorudra)
    console.log("altura: " + alturaEmM)
    console.log("FFMI: " + valorFFMI)

    setPercentualMassaMuscular(parseFloat(formatarNumero(percMuscular, 1)));
    setPercentualMassaOssea(parseFloat(formatarNumero(percOsseo, 1)));
    setPercentualPesoResidual(parseFloat(formatarNumero(percResidual, 1)));
    setFFMIcalculado(valorFFMI);
  };


  const calculaCarenciaMuscularKg = () => {
    if (peso == null || percentualGordura == null || isNaN(peso) || isNaN(percentualGordura)) {
      return null;
    }

    const percentualGorduraIdeal = sexo === "Masculino" ? 0.15 : 0.25;
    const gorduraIdeal = percentualGorduraIdeal * peso;
    const osseaEResidual = percentualPesoResidual / 100 * peso + percentualMassaOssea / 100 * peso;
    const muscularIdeal = peso - (gorduraIdeal + osseaEResidual);
    const muscularAtual = percentualMassaMuscular / 100 * peso;

    const carenciaEmKg = Math.abs(muscularIdeal - muscularAtual);

    return {
      carenciaEmKg: carenciaEmKg,
      carenciaEmPorcentagem: carenciaEmKg / peso,
    };

  };

// TABELA FFMI - MULHERES (Atualizada)
  const faixasFFMIMulheres = [
    {
      name: "Muito baixo",
      range: [0, 13.99],
      color: "#fb1d1d", // Vermelho
      laudo: "A avaliada apresenta índice de massa magra abaixo do esperado para sua altura, sugerindo necessidade de estratégias voltadas ao aumento ou preservação de massa muscular.",
      treino: "Foco em força básica, adaptação neuromuscular, progressão leve de volume, exercícios multiarticulares e acompanhamento nutricional."
    },
    {
      name: "Abaixo da média",
      range: [14.00, 15.49],
      color: "#ff8c00", // Laranja
      laudo: "A avaliada apresenta quantidade de massa magra abaixo da média, com boa margem para evolução por meio de treinamento de força e suporte nutricional adequado.",
      treino: "Foco em hipertrofia inicial, progressão de cargas, organização de rotina de treino e ênfase em constância."
    },
    {
      name: "Média",
      range: [15.50, 16.99],
      color: "#ffbb28", // Amarelo
      laudo: "A avaliada apresenta índice de massa magra dentro da média esperada para sua estatura.",
      treino: "Recomendado trabalho de recomposição corporal ou hipertrofia progressiva, conforme objetivo."
    },
    {
      name: "Bom",
      range: [17.00, 18.49],
      color: "#00c457", // Verde claro
      laudo: "A avaliada apresenta boa quantidade de massa magra para sua altura, indicando base muscular consistente e composição corporal favorável.",
      treino: "Manutenção com progressão, hipertrofia direcionada e refinamento da prescrição conforme objetivo."
    },
    {
      name: "Excelente",
      range: [18.50, 19.99],
      color: "#008f39", // Verde
      laudo: "A avaliada apresenta excelente nível de massa magra para sua estrutura corporal, compatível com indivíduos bem treinados.",
      treino: "Estratégia voltada para manutenção, hipertrofia específica ou performance."
    },
    {
      name: "Muito alto",
      range: [20.00, 99.00],
      color: "#1E90FF", // Azul
      laudo: "A avaliada apresenta índice de massa magra muito elevado, compatível com indivíduos altamente treinados.",
      treino: "Controle fino de carga, performance, manutenção e monitoramento periódico."
    },
  ];

  // TABELA FFMI - HOMENS (Atualizada)
  const faixasFFMIHomens = [
    {
      name: "Muito baixo",
      range: [0, 16.99],
      color: "#fb1d1d", // Vermelho
      laudo: "O avaliado apresenta índice de massa magra abaixo do esperado para sua altura, sugerindo necessidade de estratégias voltadas ao aumento ou preservação de massa muscular.",
      treino: "Foco em força básica, adaptação neuromuscular, progressão leve de volume, exercícios multiarticulares e acompanhamento nutricional."
    },
    {
      name: "Abaixo da média",
      range: [17.00, 18.49],
      color: "#ff8c00", // Laranja
      laudo: "O avaliado apresenta quantidade de massa magra abaixo da média, com boa margem para evolução por meio de treinamento de força e suporte nutricional adequado.",
      treino: "Foco em hipertrofia inicial, progressão de cargas e aumento gradual do volume semanal."
    },
    {
      name: "Média",
      range: [18.50, 20.49],
      color: "#ffbb28", // Amarelo
      laudo: "O avaliado apresenta índice de massa magra dentro da média esperada para sua estatura.",
      treino: "Recomendado trabalho de recomposição corporal ou hipertrofia progressiva, conforme objetivo."
    },
    {
      name: "Bom",
      range: [20.50, 22.49],
      color: "#00c457", // Verde claro
      laudo: "O avaliado apresenta boa quantidade de massa magra para sua altura, indicando base muscular consistente e composição corporal favorável.",
      treino: "Manutenção com progressão, hipertrofia direcionada e refinamento da prescrição conforme objetivo."
    },
    {
      name: "Excelente",
      range: [22.50, 24.99],
      color: "#008f39", // Verde
      laudo: "O avaliado apresenta excelente nível de massa magra para sua estrutura corporal, compatível com indivíduos bem treinados.",
      treino: "Estratégia voltada para manutenção, hipertrofia específica ou performance."
    },
    {
      name: "Muito alto",
      range: [25.00, 99.00],
      color: "#1E90FF", // Azul
      laudo: "O avaliado apresenta índice de massa magra muito elevado, compatível com indivíduos altamente treinados.",
      treino: "Controle fino de carga, performance, manutenção e monitoramento periódico."
    },
  ];

  const getFaixasFFMI = (sexo) => {
    return sexo === "Masculino" ? faixasFFMIHomens : faixasFFMIMulheres;
  };

  const faixasFFMIcalculadas = getFaixasFFMI(sexo);

  // Nova função para descobrir em qual faixa o FFMI atual se encaixa
  const getFaixaAtual = () => {
    if (FFMIcalculado == null || isNaN(FFMIcalculado)) return null;
    
    return faixasFFMIcalculadas.find(
      (faixa) => FFMIcalculado >= faixa.range[0] && FFMIcalculado <= faixa.range[1]
    );
  };

  const faixaAtual = getFaixaAtual();


  useEffect(() => {
    calculaComposicaoCorporal();
  }, [percentualGordura]);

  useEffect(() => {
    // Propaga dados da Antropometria (precedência: valor próprio sobrescreve abaixo).
    if (evaluationData?.antropometria) {
      const a = evaluationData.antropometria;
      if (a.peso !== undefined) setPeso(a.peso);
      if (a.altura !== undefined) setAltura(a.altura);
      if (a.idade !== undefined) setIdade(a.idade);
      if (a.sexo) setSexo(a.sexo);
      if (a.imc !== undefined) setIMC(a.imc);
      if (a.pescoço !== undefined) setPescoco(a.pescoço);
      if (a.abdomen !== undefined) setAbdomen(a.abdomen);
      if (a.cintura !== undefined) setCintura(a.cintura);
      if (a.quadril !== undefined) setQuadril(a.quadril);
    }

    if (evaluationData?.composicaoCorporal) {
      const c = evaluationData.composicaoCorporal;
      if (c.metodoAvaliacao) setMetodoAvaliacao(c.metodoAvaliacao);
      if (c.metodoDiretoUtilizado) setMetodoDiretoUtilizado(c.metodoDiretoUtilizado);
      if (c.protocoloAvaliacao) setProtocoloAvaliacao(c.protocoloAvaliacao);
      if (c.percentualGordura) setPercentualGordura(c.percentualGordura);

      // Campos por método. Avaliações salvas antes dessa separação só têm o protocolo/percentual
      // do último método usado — daí o fallback pelo metodoAvaliacao registrado.
      if (c.protocoloPerimetros) setProtocoloPerimetros(c.protocoloPerimetros);
      else if (c.metodoAvaliacao === "Perimetros" && c.protocoloAvaliacao) setProtocoloPerimetros(c.protocoloAvaliacao);

      if (c.protocoloDobras) setProtocoloDobras(c.protocoloDobras);
      else if (c.metodoAvaliacao === "Dobras" && c.protocoloAvaliacao) setProtocoloDobras(c.protocoloAvaliacao);

      if (c.percentualDireto) setPercentualDireto(c.percentualDireto);
      else if (c.metodoAvaliacao === "Direto" && c.percentualGordura) setPercentualDireto(c.percentualGordura);
      if (c.percentualMassaMuscular) setPercentualMassaMuscular(c.percentualMassaMuscular);
      if (c.percentualMassaOssea) setPercentualMassaOssea(c.percentualMassaOssea);
      if (c.percentualPesoResidual) setPercentualPesoResidual(c.percentualPesoResidual);
      if (c.peitoral1) setPeitoral1(c.peitoral1);
      if (c.peitoral2) setPeitoral2(c.peitoral2);
      if (c.peitoral3) setPeitoral3(c.peitoral3);
      if (c.axilar1) setAxilar1(c.axilar1);
      if (c.axilar2) setAxilar2(c.axilar2);
      if (c.axilar3) setAxilar3(c.axilar3);
      if (c.supraIliaca1) setSupraIliaca1(c.supraIliaca1);
      if (c.supraIliaca2) setSupraIliaca2(c.supraIliaca2);
      if (c.supraIliaca3) setSupraIliaca3(c.supraIliaca3);
      if (c.subescapular1) setSubescapular1(c.subescapular1);
      if (c.subescapular2) setSubescapular2(c.subescapular2);
      if (c.subescapular3) setSubescapular3(c.subescapular3);
      if (c.abdominal1) setAbdominal1(c.abdominal1);
      if (c.abdominal2) setAbdominal2(c.abdominal2);
      if (c.abdominal3) setAbdominal3(c.abdominal3);
      if (c.triceps1) setTriceps1(c.triceps1);
      if (c.triceps2) setTriceps2(c.triceps2);
      if (c.triceps3) setTriceps3(c.triceps3);
      if (c.biceps1) setBiceps1(c.biceps1);
      if (c.biceps2) setBiceps2(c.biceps2);
      if (c.biceps3) setBiceps3(c.biceps3);
      if (c.coxa1) setCoxa1(c.coxa1);
      if (c.coxa2) setCoxa2(c.coxa2);
      if (c.coxa3) setCoxa3(c.coxa3);
      if (c.panturrilha1) setPanturrilha1(c.panturrilha1);
      if (c.panturrilha2) setPanturrilha2(c.panturrilha2);
      if (c.panturrilha3) setPanturrilha3(c.panturrilha3);
    }
  }, [evaluationData]);

  const handleComposicaoCorporalRegister = async () => {
    const payload = {
      composicaoCorporal: {
        metodoAvaliacao, metodoDiretoUtilizado, protocoloAvaliacao,
        protocoloPerimetros, protocoloDobras, percentualDireto,
        percentualGordura, percentualMassaMuscular, percentualMassaOssea, percentualPesoResidual,
        peitoral1, peitoral2, peitoral3,
        axilar1, axilar2, axilar3,
        supraIliaca1, supraIliaca2, supraIliaca3,
        subescapular1, subescapular2, subescapular3,
        abdominal1, abdominal2, abdominal3,
        triceps1, triceps2, triceps3,
        biceps1, biceps2, biceps3,
        coxa1, coxa2, coxa3,
        panturrilha1, panturrilha2, panturrilha3
      },
      evaluationId
    };

    try {
      const response = await api.post(`/api/student/${aluno.id}/evaluation/composicao-corporal`, payload, { withCredentials: true });
      if (response.status === 200) {
        if (response.data.evaluationId && setEvaluationId) {
          if (!evaluationId) {
            if (!aluno.avaliacoesRealizadas) aluno.avaliacoesRealizadas = [];
            aluno.avaliacoesRealizadas.push({
              id: response.data.evaluationId,
              data: new Date().toISOString()
            });
          }
          setEvaluationId(response.data.evaluationId);
        }
        if (updateEvaluationData) {
          updateEvaluationData({ composicaoCorporal: payload.composicaoCorporal });
        }
        openNextModal();
      }
    } catch (error) {
      console.error('Erro ao salvar Composição Corporal:', error);
    }
  };

  // Navegação provisória
  const toVo2 = () => {
    setActiveTab("Vo2");
  };

  // CAP-3: bloqueia se a etapa-fonte (Antropometria) não foi preenchida.
  const antropometriaPresente = evaluationData?.antropometria?.peso !== undefined;
  if (!antropometriaPresente) {
    return (
      <EtapaFonteAusente
        etapaAtual="Composição Corporal"
        etapasFontes={[
          { nome: 'Antropometria', tabKey: 'Antropometria', presente: antropometriaPresente },
        ]}
        setActiveTab={setActiveTab}
      />
    );
  }

  return (
    <div className="avaliacao-container composicao-corporal-pagina">
      <div className="avaliacao-content">
        {etapa === 1 && (
          <div className="questions-container">
            <div className="questions-left">
              <div className="standard-title">Método de avaliação</div>
              <div className="margin-left-5 composicao-title">Selecione abaixo o médoto da avaliação:</div>
              <div className="selecao-metodo-container">
                <button className="next-prev-button metodo-button metodo-unificado" type="button" onClick={() => selecionaMetodo("Direto")}>
                  <Ruler className="icone-botao" />
                    Direto
                </button>
                <button className="next-prev-button metodo-button metodo-unificado" type="button" onClick={() => selecionaMetodo("Perimetros")}>
                  <Move3D className="icone-botao" />
                    Perímetros Corporais
                </button>
                <button className="next-prev-button metodo-button metodo-unificado" type="button" onClick={() => selecionaMetodo("Dobras")}>
                  <ScanFace className="icone-botao" />
                    Dobras Cutâneas
                </button>
              </div>
            </div>
          </div>
        )}
        {etapa === 2 && (
          <div>
            {metodoAvaliacao === "Direto" && (
              <div className="questions-container">
                <div className="questions-left">
                  <div className="standard-title title-with-info-box">
                    Método Direto
                    <div className="info-box-container" onMouseEnter={() => setShowInfoDireto(true)} onMouseLeave={() => setShowInfoDireto(false)}>
                      <div className="info-icon">
                        <Info className="info-icon-perimetros-styles info-icon-on-title" size={19} style={{ marginLeft: '5px', marginTop: '0px', marginBottom: '-5px' }} />
                      </div>
                      {showInfoDireto && (
                        <div className="info-box-content" style={{ transform: 'translateX(5vw) translateY(20vh)' }}>
                          <p className="">
                            Inserir o valor direto do percentual de gordura corporal (extraido de uma bioimpedancia, de um teste laboratorial ou de um ultrassom)
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="answer-item">
                    <div className="protocolo-container">
                      <div className="entrada-metodo-direto">
                        <p className="answer-title">Entre com o percentual de gordura:</p>
                        <input className="input-size-30 margin-left-5" type="number" name="peso" autoComplete="off" placeholder={percentualGordura} value={percentualGordura} onChange={e => { setPercentualGordura(e.target.value); setPercentualDireto(e.target.value); }} />
                        <p className="answer-title">%</p>
                      </div>
                      <div className="entrada-metodo-direto">
                        <p className="answer-title">Qual o método de coleta utilizado:</p>
                        <input className="input-metodo margin-left-5" type="text" name="metodoDiretoUtilizado" autoComplete="off" placeholder={metodoDiretoUtilizado} value={metodoDiretoUtilizado} onChange={e => setMetodoDiretoUtilizado(e.target.value)} />
                      </div>
                      <p className="resultado-porcentagem-gordura">Percentual de gordura corporal: {formatarNumero(percentualGordura, 1)}%</p>
                      <GraficoBarraComIndicador valor={percentualGordura} faixas={faixasGCcalculadas} />
                      {encontrarFaixa(percentualGordura, faixasGCcalculadas) && (
                        <div
                          className="resultado-classificacao"
                          style={{ border: `2px solid ${encontrarFaixa(percentualGordura, faixasGCcalculadas)?.color}` }}>
                          <span>
                            Classificação: <strong>{encontrarFaixa(percentualGordura, faixasGCcalculadas)?.name}</strong>
                          </span>
                        </div>
                      )}
                      <div className="legend pad-top-10">
                        {faixasGCcalculadas.map((item, index) => {
                          let label = "";

                          if (index === 0) {
                            label = `Abaixo de ${item.range[1]}%`;
                          } else if (index === faixasGCcalculadas.length - 1) {
                            label = `Acima de ${item.range[0]}%`;
                          } else {
                            label = `De ${item.range[0]}% a ${item.range[1]}%`;
                          }

                          return (
                            <div key={index} className="legend-item">
                              <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                              {label} - {item.name}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="questions-right">
                  <div className="standard-title">Análise da composição corporal</div>
                  <div className="resultadosComposicao pad-top-10 margin-left-5">
                    <div>
                      <PieChart width={150} height={150}>
                        <Pie
                          data={dataPercentualGrafico}
                          cx="50%"
                          cy="50%"
                          innerRadius={35} // Define o "furo" do gráfico (donut)
                          outerRadius={75} // Tamanho total do gráfico
                          startAngle={90} // Começa do topo
                          endAngle={90 + 360} // Progresso
                          dataKey="value"
                          stroke="none"
                        >
                          {dataPercentualGrafico.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                          ))}
                        </Pie>
                      </PieChart>
                    </div>
                    <div>
                      <div className="legend">
                        <table className="tabela-peso-mig" style={{ width: '100%', borderCollapse: 'collapse', margin: '20px 0' }}>
                          <thead>
                            <tr>
                              <th>Peso total</th>
                              <th>Peso gordo</th>
                              <th>Massa isenta de Gordura</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{peso} kg</td>
                              <td>{(peso * percentualGordura) / 100} kg</td>
                              <td>{formatarNumero((peso - ((peso * percentualGordura) / 100)), 2)} kg</td>
                            </tr>
                          </tbody>
                        </table>
                        {dataPercentualGrafico.map((item, index) => (
                          <div key={index} className="legend-item">
                            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                            {item.name} : {item.value}% / {formatarNumero((peso * (item.value / 100)), 2)}Kg
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <div className="standard-title titulo-massa-muscular">Análise de massa muscular</div>
                  <div className="adicional-info-container pad-top-10 margin-left-5">
                    <p className="adicional-info-title">Análise do FFMI (Fat Free Mass Index)</p>
                    
                    {/* O gráfico original continua recebendo o valor e as faixas atualizadas */}
                    <GraficoBarraComIndicador valor={FFMIcalculado} faixas={faixasFFMIcalculadas} />
                    
                    {FFMIcalculado ? (
                      <div className="ffmi-resultado-detalhado" style={{ marginTop: '15px' }}>
                        <div className="ffmi-linha">
                          <p className="adicional-info-content">
                            <strong>FFMI:</strong> {formatarNumero(FFMIcalculado, 2)}
                          </p>
                          <p className="adicional-info-content">
                            <strong>|</strong>
                          </p>
                          {faixaAtual && (
                            <p className="adicional-info-content">
                              <strong>Classificação:</strong>{' '}
                              <span style={{ color: faixaAtual.color, fontWeight: 'bold' }}>
                                {faixaAtual.name}
                              </span>
                            </p>
                          )}
                        </div>
                        {faixaAtual && (
                          <>
                            {/* Botão do laudo em linha própria, logo abaixo de FFMI | Classificação */}
                            <a 
                              className="adicional-info-content-button"
                              onClick={() => setModalLaudoETreino(true)} 
                            >
                              Ver Laudo e Sugestão de treino
                            </a>

                            <Modal
                              isOpen={modalLaudoETreino}
                              contentLabel="Confirmacao"
                              className="modal-next modal-info-laudo"
                              overlayClassName="popup-overlay"
                            >
                              <div>
                                <p className="adicional-info-content" style={{ marginTop: '8px' }}>
                                  <strong>Laudo:</strong> {faixaAtual.laudo}
                                </p>
                                
                                <p className="adicional-info-content" style={{ marginTop: '15px', marginBottom: '15px' }}>
                                  <strong>Sugestão de Treino:</strong> {faixaAtual.treino}
                                </p>

                                <p className="adicional-info-content" style={{ marginBottom: '15px' }}>
                                  <strong>FFMI (Índice de Massa Livre de Gordura): </strong>É um indicador utilizado para avaliar a quantidade de massa magra do indivíduo em relação à sua altura. Diferente da análise isolada da massa muscular em quilogramas, o FFMI ajusta esse valor ao tamanho corporal, permitindo uma interpretação mais precisa da estrutura física do avaliado. <br/>
                                          Esse índice é importante porque ajuda a identificar se a quantidade de massa magra está abaixo, dentro ou acima do esperado para a estatura do indivíduo, auxiliando na análise da composição corporal, no planejamento do treinamento e no acompanhamento da evolução física.<br/>
                                          Níveis adequados de massa magra estão associados a melhor desempenho físico, maior força, melhor metabolismo e composição corporal mais saudável.<br/>
                                </p>
                              </div>
                              <div className="sub-pagination-buttons">
                                {/* CORREÇÃO: Adicionado () => antes de chamar o state */}
                                <button 
                                  className="next-prev-button" 
                                  type="button" 
                                  onClick={() => setModalLaudoETreino(false)}
                                >
                                  Fechar
                                </button>
                              </div>
                            </Modal>
                          </>
                        )}
                      </div>
                    ) : (
                      <p className="adicional-info-content">Aguardando dados para calcular o FFMI...</p>
                    )}
                    
                    {/* Seus comentários originais mantidos abaixo caso precise reativar futuramente */}
                    {/* 
                    <p className="adicional-info-content">Gordura excedente: {avaliarPercentuais().gorduraExcedente}</p>
                    <p className="adicional-info-content">Carência muscular: {formatarNumero((calculaCarenciaMuscularKg().carenciaEmPorcentagem * 100), 2)}% / {formatarNumero((calculaCarenciaMuscularKg().carenciaEmKg), 2)}kg</p>
                    */}
                  </div>

                </div>
              </div>
            )}
            {metodoAvaliacao === "Perimetros" && (
              <div className="questions-container">
                <div className="questions-left">
                  <div className="standard-title title-with-info-box">
                    Perimetros Corporais
                    <div className="info-box-container" onMouseEnter={() => setShowInfoPerimetros(true)} onMouseLeave={() => setShowInfoPerimetros(false)}>
                      <div className="info-icon">
                        <Info className="info-icon-perimetros-styles info-icon-on-title" size={19} style={{ marginLeft: '5px', marginTop: '0px', marginBottom: '-5px' }} />
                      </div>
                      {showInfoPerimetros && (
                        <div className="info-box-content" style={{ transform: 'translateX(5vw) translateY(28vh)' }}>
                          <p className="">
                            A análise por perímetros corporais utiliza medidas de circunferências em regiões específicas do corpo, como cintura, abdômen, quadril, braços e coxas, para estimar padrões de distribuição de gordura corporal e acompanhar mudanças na composição física. É um método prático, acessível e muito útil para monitoramento de evolução, controle de riscos metabólicos e avaliação de proporcionalidade corporal.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="protocolo-container">
                    <div className="answer-item protrocolo-content flex-column">
                      <div>Selecione o protocolo: </div>
                      <select className="selecao-protocolo" value={protocoloAvaliacao} onChange={calculaPercentualProtocolo}>
                        <option value="">Selecione</option>
                        {protocolosPerimetros.map((p) => (
                          <option key={p.value} value={p.value}>
                            {p.label}
                          </option>
                        ))}
                      </select>
                      <a className="protocolos-sugeridos-btt" onClick={() => {
                        openProtocoloTypeModal("by-button");
                      }}>
                        Ver protocolos sugeridos
                      </a>
                    </div>
                    <p className="antropometria-result">Perceltual calculado: {formatarNumero(percentualGordura, 2)}%</p>
                    <GraficoBarraComIndicador valor={percentualGordura} faixas={faixasGCcalculadas} />
                    {encontrarFaixa(percentualGordura, faixasGCcalculadas) && (
                      <div
                        className="resultado-classificacao"
                        style={{ border: `2px solid ${encontrarFaixa(percentualGordura, faixasGCcalculadas)?.color}`, }}>
                        <span>
                          Classificação: <strong>{encontrarFaixa(percentualGordura, faixasGCcalculadas)?.name}</strong>
                        </span>
                      </div>
                    )}
                    <div className="legend pad-top-10">
                      {faixasGCcalculadas.map((item, index) => {
                        let label = "";

                        if (index === 0) {
                          label = `Abaixo de ${item.range[1]}%`;
                        } else if (index === faixasGCcalculadas.length - 1) {
                          label = `Acima de ${item.range[0]}%`;
                        } else {
                          label = `De ${item.range[0]}% a ${item.range[1]}%`;
                        }

                        return (
                          <div key={index} className="legend-item">
                            <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                            {label} - {item.name}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="questions-right">
                  <div className="standard-title">Análise da composição corporal</div>
                  <table className="composicao-table">
                    <thead>
                      <tr>
                        <th>Indicadores</th>
                        <th>Resultados</th>
                        <th>Classificação</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Peso</td>
                        <td>{peso} Kg</td>
                        <td>{avaliarPercentualGordura(percentualGordura, faixasGCcalculadas).tipoMeta}</td>
                      </tr>
                      <tr>
                        <td>Gordura</td>
                        <td>
                          {!isNaN(Number(percentualGordura)) ? formatarNumero(percentualGordura, 2) : "--"} %
                        </td>
                        <td>{avaliarPercentualGordura(percentualGordura, faixasGCcalculadas).detalheMeta}</td>
                      </tr>
                      <tr>
                        <td>MIG</td>
                        <td>
                          {!isNaN(Number(percentualGordura))
                            ? formatarNumero((100 - Number(percentualGordura)), 2)
                            : "--"} %
                        </td>
                        <td>{avaliarPercentualGordura(percentualGordura, faixasGCcalculadas).gordura}</td>
                      </tr>
                      <tr>
                        <td>Peso Gordura</td>
                        <td>
                          {!isNaN(Number(percentualGordura))
                            ? formatarNumero((Number(percentualGordura) / 100 * peso), 2)
                            : "--"} Kg
                        </td>
                        <td>{avaliarPercentualGordura(percentualGordura, faixasGCcalculadas).ideal}</td>
                      </tr>
                      <tr>
                        <td>Peso MIG</td>
                        <td>
                          {!isNaN(Number(percentualGordura))
                            ? formatarNumero(((100 - Number(percentualGordura)) / 100 * peso), 2)
                            : "--"} Kg
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
            {metodoAvaliacao === "Dobras" && (
              <div className="questions-container">
                <div className="questions-left">
                  <div className="standard-title title-with-info-box">
                    Dobras Cutâneas
                    <div className="info-box-container" onMouseEnter={() => setShowInfoDobras(true)} onMouseLeave={() => setShowInfoDobras(false)}>
                      <div className="info-icon">
                        <Info className="info-icon-perimetros-styles info-icon-on-title" size={19} style={{ marginLeft: '5px', marginTop: '0px', marginBottom: '-5px' }} />
                      </div>
                      {showInfoDobras && (
                        <div className="info-box-content" style={{ transform: 'translateX(5vw) translateY(30vh)' }}>
                          <p className="">
                            A análise por dobras cutâneas é realizada por meio da mensuração da espessura da gordura subcutânea em pontos anatômicos específicos, utilizando um adipômetro. A partir desses dados, é possível estimar o percentual de gordura corporal de forma mais precisa, sendo um dos métodos mais utilizados na avaliação física para acompanhamento de emagrecimento, hipertrofia e planejamento de estratégias de treinamento e nutrição.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <table className="tabela-dobras">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Medida 1</th>
                        <th>Medida 2</th>
                        <th>Medida 3</th>
                        <th>Média</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          Peitoral (PT):
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="peitoral1" placeholder={peitoral1} value={peitoral1} onFocus={() => setShowInfoLegendaCorpo("peitoral")} onClick={() => setImagemDobra(imgDobraPeitoral)} onChange={e => setPeitoral1(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="peitoral2" placeholder={peitoral2} value={peitoral2} onFocus={() => setShowInfoLegendaCorpo("peitoral")} onClick={() => setImagemDobra(imgDobraPeitoral)} onChange={e => setPeitoral2(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="peitoral3" placeholder={peitoral3} value={peitoral3} onFocus={() => setShowInfoLegendaCorpo("peitoral")} onClick={() => setImagemDobra(imgDobraPeitoral)} onChange={e => setPeitoral3(e.target.value)} />
                        </td>
                        <td>
                          <p>{formatarNumero((mediaPeitoral || 0), 2)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Axilar média (AM):
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="axilar1" placeholder={axilar1} value={axilar1} onFocus={() => setShowInfoLegendaCorpo("axilar")} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setAxilar1(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="axilar2" placeholder={axilar2} value={axilar2} onFocus={() => setShowInfoLegendaCorpo("axilar")} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setAxilar2(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="axilar3" placeholder={axilar3} value={axilar3} onFocus={() => setShowInfoLegendaCorpo("axilar")} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setAxilar3(e.target.value)} />
                        </td>
                        <td>
                          <p>{formatarNumero((mediaAxilar || 0), 2)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Supra ilíaca (SI):
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="supraIliaca1" placeholder={supraIliaca1} onFocus={() => setShowInfoLegendaCorpo("supraIliaca")} value={supraIliaca1} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setSupraIliaca1(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="supraIliaca2" placeholder={supraIliaca2} onFocus={() => setShowInfoLegendaCorpo("supraIliaca")} value={supraIliaca2} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setSupraIliaca2(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="supraIliaca3" placeholder={supraIliaca3} onFocus={() => setShowInfoLegendaCorpo("supraIliaca")} value={supraIliaca3} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setSupraIliaca3(e.target.value)} />
                        </td>
                        <td>
                          <p>{formatarNumero((mediaIliaca || 0), 2)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Subescapular (SE):
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="subescapular1" placeholder={subescapular1} onFocus={() => setShowInfoLegendaCorpo("subEscapular")} value={subescapular1} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setSubescapular1(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="subescapular2" placeholder={subescapular2} onFocus={() => setShowInfoLegendaCorpo("subEscapular")} value={subescapular2} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setSubescapular2(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="subescapular3" placeholder={subescapular3} onFocus={() => setShowInfoLegendaCorpo("subEscapular")} value={subescapular3} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setSubescapular3(e.target.value)} />
                        </td>
                        <td>
                          <p>{formatarNumero((mediaSubescapular || 0), 2)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Abdominal (ABD):
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="abdominal1" placeholder={abdominal1} onFocus={() => setShowInfoLegendaCorpo("abdominal")} value={abdominal1} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setAbdominal1(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="abdominal2" placeholder={abdominal2} onFocus={() => setShowInfoLegendaCorpo("abdominal")} value={abdominal2} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setAbdominal2(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="abdominal3" placeholder={abdominal3} onFocus={() => setShowInfoLegendaCorpo("abdominal")} value={abdominal3} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setAbdominal3(e.target.value)} />
                        </td>
                        <td>
                          <p>{formatarNumero((mediaAbdominal || 0), 2)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Tríceps (TR):
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="triceps1" placeholder={triceps1} onFocus={() => setShowInfoLegendaCorpo("triceps")} value={triceps1} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setTriceps1(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="triceps2" placeholder={triceps2} onFocus={() => setShowInfoLegendaCorpo("triceps")} value={triceps2} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setTriceps2(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="triceps3" placeholder={triceps3} onFocus={() => setShowInfoLegendaCorpo("triceps")} value={triceps3} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setTriceps3(e.target.value)} />
                        </td>
                        <td>
                          <p>{formatarNumero((mediaTriceps || 0), 2)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Bíceps (BI):
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="biceps1" placeholder={biceps1} onFocus={() => setShowInfoLegendaCorpo("biceps")} value={biceps1} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setBiceps1(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="biceps2" placeholder={biceps2} onFocus={() => setShowInfoLegendaCorpo("biceps")} value={biceps2} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setBiceps2(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="biceps3" placeholder={biceps3} onFocus={() => setShowInfoLegendaCorpo("biceps")} value={biceps3} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setBiceps3(e.target.value)} />
                        </td>
                        <td>
                          <p>{formatarNumero((mediaBiceps || 0), 2)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Coxa medial (CX):
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="coxa1" placeholder={coxa1} onFocus={() => setShowInfoLegendaCorpo("coxa")} value={coxa1} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setCoxa1(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="coxa2" placeholder={coxa2} onFocus={() => setShowInfoLegendaCorpo("coxa")} value={coxa2} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setCoxa2(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="coxa3" placeholder={coxa3} onFocus={() => setShowInfoLegendaCorpo("coxa")} value={coxa3} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setCoxa3(e.target.value)} />
                        </td>
                        <td>
                          <p>{formatarNumero((mediaCoxa || 0), 2)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Panturrilha (PR):
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="panturrilha1" placeholder={panturrilha1} onFocus={() => setShowInfoLegendaCorpo("panturrilha")} value={panturrilha1} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setPanturrilha1(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="panturrilha2" placeholder={panturrilha2} onFocus={() => setShowInfoLegendaCorpo("panturrilha")} value={panturrilha2} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setPanturrilha2(e.target.value)} />
                        </td>
                        <td>
                          <input className="entrada-dobra" autoComplete="off" type="text" name="panturrilha3" placeholder={panturrilha3} onFocus={() => setShowInfoLegendaCorpo("panturrilha")} value={panturrilha3} onClick={() => setImagemDobra(imgDobraAxilar)} onChange={e => setPanturrilha3(e.target.value)} />
                        </td>
                        <td>
                          <p>{formatarNumero((mediaPanturrilha || 0), 2)}</p>
                        </td>
                      </tr>
                      <tr>
                        <td>Somatória total:</td>
                        <td>{calcularSomatoriaColuna(0)}</td>
                        <td>{calcularSomatoriaColuna(1)}</td>
                        <td>{calcularSomatoriaColuna(2)}</td>
                        <td>{calcularSomatoriaColuna(3)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="questions-right img-dobra-container">
                  {imagemDobra ? (
                    <img className="img-dobra" src={imagemDobra} alt="Dobra corporal" />
                  ) : (
                    <div></div>
                  )}
                  {showInfoLegendaCorpo === "peitoral" && (
                    <p className="body-legenda legenda-comp">
                      <span className="img-legenda-title">Localização da medida:</span>
                      <span className="img-legenda-text">Homens: metade da distância entre a linha axilar anterior e o mamilo<br />
                        Mulheres: um terço da distância entre a linha axilar anterior e o mamilo<br />
                        Sentido da dobra: diagonal em relação ao solo, próximo ao ângulo de 45º<br />
                        Posição do compasso: diagonal em relação ao solo, próximo ao ângulo de 45º
                      </span>
                    </p>
                  )}
                  {showInfoLegendaCorpo === "axilar" && (
                    <p className="body-legenda legenda-comp">
                      <span className="img-legenda-title">Localização da medida:</span>
                      <span className="img-legenda-text">Intersecção da linha axilar média , ao nível do apêndice xifóide, no esterno<br />
                        Sentido da dobra: diagonal em relação ao solo, próximo ao ângulo de 45º<br />
                        Posição do compasso: diagonal em relação ao solo, próximo ao ângulo de 45º
                      </span>
                    </p>
                  )}
                  {showInfoLegendaCorpo === "supraIliaca" && (
                    <p className="body-legenda legenda-comp">
                      <span className="img-legenda-title">Localização da medida:</span>
                      <span className="img-legenda-text">2cm acima da espinha ilíaca antero-posterior na altura da linha axilar anterior<br />
                        Sentido da dobra: diagonal em relação ao solo, próximo ao ângulo de 45º<br />
                        Posição do compasso: diagonal em relação ao solo, próximo ao ângulo de 45º
                      </span>
                    </p>
                  )}
                  {showInfoLegendaCorpo === "subEscapular" && (
                    <p className="body-legenda legenda-comp">
                      <span className="img-legenda-title">Localização da medida:</span>
                      <span className="img-legenda-text">Seguindo as orientações dos arcos costais, 2cm abaixo do ângulo inferior da escápula<br />
                        Sentido da dobra: diagonal em relação ao solo, próximo ao ângulo de 45º<br />
                        Posição do compasso: diagonal em relação ao solo, próximo ao ângulo de 45º
                      </span>
                    </p>
                  )}
                  {showInfoLegendaCorpo === "abdominal" && (
                    <p className="body-legenda legenda-comp">
                      <span className="img-legenda-title">Localização da medida:</span>
                      <span className="img-legenda-text">2cm á direita da borda da cicatriz umbilical<br />
                        Sentido da dobra: vertical em relação ao solo<br />
                        Posição do compasso: horizontal em relação ao solo
                      </span>
                    </p>
                  )}
                  {showInfoLegendaCorpo === "triceps" && (
                    <p className="body-legenda legenda-comp">
                      <span className="img-legenda-title">Localização da medida:</span>
                      <span className="img-legenda-text">Face posterior do braço, no ponto médio entre acrômio e olecrano<br />
                        Sentido da dobra: vertical em relação ao solo<br />
                        Posição do compasso: horizontal em relação ao solo
                      </span>
                    </p>
                  )}
                  {showInfoLegendaCorpo === "biceps" && (
                    <p className="body-legenda legenda-comp">
                      <span className="img-legenda-title">Localização da medida:</span>
                      <span className="img-legenda-text">Face anterior do braço, no ponto médio entre acrômio e olécrano<br />
                        Sentido da dobra: vertical em relação ao solo<br />
                        Posição do compasso: horizontal em relação ao solo</span>
                    </p>
                  )}
                  {showInfoLegendaCorpo === "coxa" && (
                    <p className="body-legenda legenda-comp">
                      <span className="img-legenda-title">Localização da medida:</span>
                      <span className="img-legenda-text">Distância média entre o trocânter femural e a borda superior da patela<br />
                        Sentido da dobra: vertical em relação ao solo<br />
                        Posição do compasso: horizontal em relação ao solo
                      </span>
                    </p>
                  )}
                  {showInfoLegendaCorpo === "panturrilha" && (
                    <p className="body-legenda legenda-comp">
                      <span className="img-legenda-title">Localização da medida:</span>
                      <span className="img-legenda-text">Com o avaliado na posição sentada, localizar a face interna da perna, no ponto de maior circunferência visível<br />
                        Sentido da dobra: vertical em relação ao solo<br />
                        Posição do compasso: horizontal em relação ao solo
                      </span>
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
        {etapa === 3 && (
          <div className="questions-container">
            <div className="questions-left">
              <div className="standard-title">Dobras Cutaneas</div>
              <div className="protocolo-container">
                <div className="answer-item flex-column">
                  <div>Selecione o protocolo: </div>
                  <select className="selecao-protocolo" value={protocoloAvaliacao} onChange={calculaPercentualProtocolo}>
                    <option value="">Selecione</option>
                    {protocolosDobras.map((p) => (
                      <option key={p.value} value={p.value}>
                        {p.label}
                      </option>
                    ))}
                  </select>
                  <a className="protocolos-sugeridos-btt" onClick={() => {
                    openProtocoloTypeModal("by-button");
                  }}>
                    Ver protocolos sugeridos
                  </a>
                </div>
                <p className="antropometria-result" style={{ marginTop: 10, marginBottom: 15 }}>Percentual calculado: {formatarNumero(percentualGordura, 2)}%</p>
                <GraficoBarraComIndicador valor={percentualGordura} faixas={faixasGCcalculadas} />
                {encontrarFaixa(percentualGordura, faixasGCcalculadas) && (
                  <div
                    className="resultado-classificacao"
                    style={{ border: `2px solid ${encontrarFaixa(percentualGordura, faixasGCcalculadas)?.color}`, marginTop: 20, marginBottom: 0 }}>
                    <span>
                      Classificação: <strong>{encontrarFaixa(percentualGordura, faixasGCcalculadas)?.name}</strong>
                    </span>
                  </div>
                )}
                <div className="legend pad-top-10">
                  {faixasGCcalculadas.map((item, index) => {
                    let label = "";

                    if (index === 0) {
                      label = `Abaixo de ${item.range[1]}%`;
                    } else if (index === faixasGCcalculadas.length - 1) {
                      label = `Acima de ${item.range[0]}%`;
                    } else {
                      label = `De ${item.range[0]}% a ${item.range[1]}%`;
                    }

                    return (
                      <div key={index} className="legend-item">
                        <span className="legend-color" style={{ backgroundColor: item.color }}></span>
                        {label} - {item.name}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="questions-right">
              <div className="standard-title">Análise da composição corporal</div>
              <table className="composicao-table">
                <thead>
                  <tr>
                    <th>Indicadores</th>
                    <th>Resultados</th>
                    <th>Classificação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Peso</td>
                    <td>{peso} Kg</td>
                    <td>{avaliarPercentualGordura(percentualGordura, faixasGCcalculadas).tipoMeta}</td>
                  </tr>
                  <tr>
                    <td>Gordura</td>
                    <td>
                      {!isNaN(Number(percentualGordura)) ? formatarNumero(percentualGordura, 2) : "--"} %
                    </td>
                    <td>{avaliarPercentualGordura(percentualGordura, faixasGCcalculadas).detalheMeta}</td>
                  </tr>
                  <tr>
                    <td>MIG</td>
                    <td>
                      {!isNaN(Number(percentualGordura))
                        ? formatarNumero((100 - Number(percentualGordura)), 2)
                        : "--"} %
                    </td>
                    <td>{avaliarPercentualGordura(percentualGordura, faixasGCcalculadas).gordura}</td>
                  </tr>
                  <tr>
                    <td>Peso Gordura</td>
                    <td>
                      {!isNaN(Number(percentualGordura))
                        ? formatarNumero((Number(percentualGordura) / 100 * peso), 2)
                        : "--"} Kg
                    </td>
                    <td>{avaliarPercentualGordura(percentualGordura, faixasGCcalculadas).ideal}</td>
                  </tr>
                  <tr>
                    <td>Peso MIG</td>
                    <td>
                      {!isNaN(Number(percentualGordura))
                        ? formatarNumero(((100 - Number(percentualGordura)) / 100 * peso), 2)
                        : "--"} Kg
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        <Modal
          isOpen={isProtocoloTypeModal}
          onRequestClose={closeProtocoloTypeModal}
          contentLabel="Confirmação"
          className="modal-next modal-protocolos"
          overlayClassName="popup-overlay"
        >
          <p className="answer-title text-center">
            De acordo com o perfil do avaliado, os protocolos recomendados e compatíveis são:
          </p>

          <ul className="modal-protocolos-list">
            {protocolosCompatíveis.map((p) => (
              <li key={p.value}>
                {p.label}
              </li>
            ))}
          </ul>

          <label htmlFor="protocolo-select" className="answer-title text-center">
            Selecione o protocolo desejado:
          </label>

          <select
            id="protocolo-select"
            className="selecao-protocolo"
            value={protocoloAvaliacao}
            style={{ marginTop: 10, marginBottom: 10 }}
            onChange={(e) => aplicaProtocolo(e.target.value)}
          >
            <option value="">Selecione</option>
            {opcoesProtocoloModal.map((protocolo) => (
              <option key={protocolo.value} value={protocolo.value}>
                {protocolo.label}
              </option>
            ))}
          </select>

          <div>
            <button className="next-prev-button" type="button" onClick={closeProtocoloTypeModal}>
              Continuar
            </button>
          </div>
        </Modal>

        <Modal
          isOpen={isNextModal}
          onRequestClose={closeNextModal}
          contentLabel="Confirmacao"
          className="modal-next"
          overlayClassName="popup-overlay"
        >
          <p className="popupNext-h1">Composição Corporal finalizada!</p>
          <p className="popupNext-h2">Deseja ir para o VO2 máx?</p>
          <div className="sub-pagination-buttons">
            <button className="next-prev-button" type="button" onClick={toVo2}>
              Sim
            </button>
            <button className="next-prev-button" type="button" onClick={closeNextModal}>
              Não
            </button>
          </div>
        </Modal>

        <div className="pagination-footer">
          <div className="sub-pagination-footer">
            <div className="sub-pagination-buttons">
              {etapa > 0 && (
                <button className="next-prev-button" type="button" onClick={retrocederEtapa}>
                  Voltar
                </button>
              )}
              {etapa < totalEtapas ? (
                <button className="next-prev-button" type="button" onClick={avancarEtapa}>
                  Avançar
                </button>
              ) : (
                <button className="next-prev-button" type="button" onClick={handleComposicaoCorporalRegister}>Registrar</button>
              )}
            </div>
            <div className="progress-container">
              <div className="progress-bar" style={{ width: `${porcentagemConclusao}%` }}></div>
            </div>
          </div>
          <div className="info-box-container">
            <div>
              <div className="info-button" onMouseEnter={() => setShowInfo(true)} onMouseLeave={() => setShowInfo(false)}>
                <HelpCircle size={20} />
                Mais informações
              </div>
              {showInfo && (
                <div className="info-box-content">
                  <div>
                    <p className="">
                      Composição corporal é a análise das proporções que compõem o corpo humano, principalmente massa muscular, gordura corporal, massa óssea e água corporal. Diferente do peso corporal isolado, essa avaliação permite compreender com mais precisão a qualidade do peso, identificando quanto dele representa tecido magro ou gordura.
                      <br /><br />
                      Sua análise é fundamental para objetivos como emagrecimento, hipertrofia, desempenho esportivo e promoção da saúde, auxiliando na prescrição mais individualizada de treinamento e estratégias nutricionais.
                      <br /><br />
                      Por meio de diferentes métodos de avaliação, a composição corporal fornece dados importantes para monitorar evolução física, prevenir riscos à saúde e orientar decisões mais assertivas no planejamento corporal.
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    </div>
  );

}

export default ComposicaoCorporal;
